import dynamic from 'next/dynamic';

const CreateJourney = dynamic(() => import('./CreateJourney'));

export default CreateJourney
